import { SearchParams } from '../searches/types'
import { ContractorItem } from '../types'
import {
  ContractorsActions, ContractorsType, contractorsTypes, RequestPayload
} from './types'

const actions = {
  setContractor: (payload: ContractorItem): ContractorsActions => ({
    type: contractorsTypes.SET_CONTRACTOR,
    payload,
  }),

  fetchContractors: (
    payload?: {
      page?: number
      size?: number
      searchParams?: Partial<SearchParams>
      institutional?: boolean | null
    },
    callback?: (succ: boolean) => void
  ): ContractorsActions => ({
    type: contractorsTypes.FETCH_CONTRACTORS,
    payload,
    callback,
  }),

  fetchAllContractors: (
    payload?: {
      page?: number
      size?: number
      searchParams?: Partial<SearchParams>
      institutional?: boolean | null
    },
    callback?: (succ: boolean) => void
  ): ContractorsActions => ({
    type: contractorsTypes.FETCH_ALL_CONTRACTORS,
    payload,
    callback,
  }),

  createContractor: (
    payload: RequestPayload,
    callback: (succ: boolean, contractor?: ContractorItem) => void
  ): ContractorsActions => ({
    type: contractorsTypes.CREATE_CONTRACTOR,
    payload,
    callback,
  }),

  updateContractor: (
    payload: RequestPayload,
    callback: (succ: boolean) => void
  ): ContractorsActions => ({
    type: contractorsTypes.UPDATE_CONTRACTOR,
    payload,
    callback,
  }),

  patchContractor: (
    payload: RequestPayload,
    callback: (succ: boolean) => void
  ): ContractorsActions => ({
    type: contractorsTypes.PATCH_CONTRACTOR,
    payload,
    callback,
  }),

  deleteContractor: (
    payload: RequestPayload,
    callback: (succ: boolean) => void
  ): ContractorsActions => ({
    type: contractorsTypes.DELETE_CONTRACTOR,
    payload,
    callback,
  }),
  activateContractor: (
    payload: string,
    callback: (succ: boolean) => void
  ): ContractorsActions => ({
    type: contractorsTypes.ACTIVATE_CONTRACTOR,
    payload,
    callback,
  }),
  deactivateContractor: (
    payload: string,
    callback: (succ: boolean) => void
  ): ContractorsActions => ({
    type: contractorsTypes.DEACTIVATE_CONTRACTOR,
    payload,
    callback,
  }),
  setContractors: (payload: ContractorsType): ContractorsActions => ({
    type: contractorsTypes.SET_CONTRACTORS,
    payload,
  }),

  setAllContractors: (payload: ContractorItem[]): ContractorsActions => ({
    type: contractorsTypes.SET_ALL_CONTRACTORS,
    payload,
  }),
  setContractorTerritory: (payload: { contractorId: string, territoryId: string }, callback: (succ: boolean) => void): ContractorsActions => ({
    type: contractorsTypes.SET_CONTRACTOR_TERRITORY,
    payload,
    callback,
  }),
  deleteContractorTerritory: (payload: { contractorId: string, territoryId: string }, callback: (succ: boolean) => void): ContractorsActions => ({
    type: contractorsTypes.DELETE_CONTRACTOR_TERRITORY,
    payload,
    callback,
  }),
}

export default actions
